import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { useAuth } from "../../../../store/auth";
import { toast } from "react-toastify";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const WeighBridgeReport = () => {
  const printRef = useRef();
  const { orgData } = useAuth();
  const frmRef = useRef({});
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const formatNumber = (num) => {
    if (num === null || num === undefined) return "0.00";
    return Number(num).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
    content: {
      top: "50%",
      left: "60%",
      transform: "translate(-50%, -50%)",
      maxWidth: "90%",
      width: "900px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      // border: "5px solid #96dc00",
    },
  };
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [seasonId, setSeasonId] = useState([]);
  const [seasondata, setSeasondata] = useState([]);
  const [vehicleId, setvehicleId] = useState();
  const [vehicleData, setVehicleData] = useState([]);
  const [cropId, setCropId] = useState("");
  const [cropData, setCropData] = useState([]);

  const [identificationNumber, setIdentificationNumber] = useState();

  const [identificationData, setIdentificationData] = useState();

  const [showDateFilter, setShowDateFilter] = useState(false);

  const [logoBase64, setLogoBase64] = useState("");

  const [logoSrc, setLogoSrc] = useState("");

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data?.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const pdfContainerRef = useRef(null);
  const [pdfView, setPdfView] = useState(false);
  const [pdfData, setPdfData] = useState([]);

  const { sendRequest: getPdfData } = useHttp();

  const viewPdf = (data) => {
    setPdfView(true);

    const Id = data?.vehicleWeighBridgeId;
    if (!Id) return;

    getPdfData(
      {
        url: `/api/vehicleWeighBridge/?orgId=${localStorage.getItem(
          "orgId"
        )}&vehicleWeighBridgeId=${Id}`,
      },
      (responseData) => {
        if (responseData) {
          setPdfData(responseData);
          console.log("PDF Data:", responseData);
        } else {
          console.warn("No data received for PDF view.");
        }
      }
    );
  };

  const generatePDF = (title) => {
    const input = printRef.current;
    if (!input) return;

    html2canvas(input, { scale: 3, useCORS: true }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "pt", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // Add content
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      // 🔥 DARK BORDER (True black)
      pdf.setLineWidth(2);              // Thickness
      pdf.setDrawColor(0, 0, 0);         // Pure black
      pdf.rect(10, 10, pdfWidth - 20, pdfHeight - 20); // Draw border

      pdf.save(`${title || "report"}_${new Date().toISOString()}.pdf`);
    });
  };





  const { sendRequest: getWarehouseData } = useHttp();

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const fillprocurementData = () => {
    var urlfilter = "";

    console.log("vehicleId", vehicleId);

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }
    // if (GroupId > 0) {
    //   urlfilter = urlfilter + `&nurseryGroupSiteId=${nurseryGroupId}`;
    // }

    if (seasonId > 0) {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }
    if (vehicleId > 0) {
      urlfilter = urlfilter + `&vehicleId=${vehicleId}`;
    }

    if (cropId && cropId !== "") {
      urlfilter += `&cropId=${cropId}`;
    }
    // if (identificationNumber != "") {
    //   urlfilter = urlfilter + `&identificationNo=${identificationNumber}`;
    // }

    var url = `/api/vehicleWeighBridgeReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (response) => {
        const reportList = response.reportData || [];

        // 🔹 Sort entries so that the latest ones appear at the top
        const sortedData = [...reportList].sort((a, b) => {
          const dateA = new Date(a.harvstDate);
          const dateB = new Date(b.harvstDate);
          return dateB - dateA; // Descending order (newest first)
        });

        setData(sortedData);
      }
    );
  };

  // useEffect(() => {
  //   fillprocurementData();
  // }, [getprocurementData]);

  useEffect(() => {
    fillprocurementData();
  }, [
    cropId,
    seasonId,
    vehicleId,
    employeeId,
    selectedFromDate,
    selectedToDate,
    showDateFilter,
  ]);

  const fieldsToExport = [
    "harvstDate",
    "VehicleCode",
    "tripId",
    "seasonName",
    "totalCratesBagQtyLoaded",
    "loadedVehicleWeightTons",
    "emptyVehicleWeightTons",
    "averageEmptyCratesWeightInKg",
    "totalWeightofEmptyCrate",
    "netWeightTons",
    "averageWeightOfCrates",
  ];

  const customHeaders = [
    "Harvest Date",
    "Truck ID",
    "Trip No",
    "Season Name",
    "Total Number of Crates",
    "TARE Weight",
    "Empty Wt of Truck",
    "Weight of Crate",
    "Total Weight of Crate",
    "Adjusted weight",
    "Average weight of crate",
  ];

  const handleExportExcel = () => {
    if (!data || data.length === 0) {
      toast.error("No data available to export!");
      return;
    }
    const filename = "Weighbridgereport.xlsx";

    convertToExcel(data, fieldsToExport, filename, customHeaders);
  };

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (season) => {
    var urlfilter = "";

    if (season > 0) {
      urlfilter = urlfilter + `&seasonId=${season}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };
  const { sendRequest: getCropData } = useHttp();

  useEffect(() => {
    getCropData(
      {
        url: `/api/farmerCropList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setCropData(data.output || []);
      }
    );
  }, [getCropData]);

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  // const { sendRequest: getSeason } = useHttp();
  // useEffect(() => {
  //   getSeason(
  //     {
  //       url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
  //     },
  //     (data) => {
  //       setSeasonData(data);
  //     }
  //   );
  // }, [getSeason]);

  const { sendRequest: getVehicle } = useHttp();
  useEffect(() => {
    getVehicle(
      {
        url: `/api/vehicleMachineEquipRegistratn/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        setVehicleData(data);
      }
    );
  }, [getVehicle]);

  const { sendRequest: getIdentificationNumber } = useHttp();
  useEffect(() => {
    getIdentificationNumber(
      {
        url: `/api/farmerIdentificationlist/?orgId=${localStorage.getItem(
          "orgId"
        )}&fieldExecutiveId=${employeeId}`,
      },
      (data) => {
        setIdentificationData(data);
      }
    );
  }, [employeeId]);

  const handleSearch = (value) => {
    setIdentificationNumber(value);
  };

  // const options = identificationData&&identificationData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    identificationData &&
    identificationData
      .filter((item) => item.identificationNo.includes(identificationNumber))
      .map((item) => ({ value: item.identificationNo }));

  const handleView = (item) => {
    setPdfView(true);

    const Id = data.orgId || 0;
    if (Id) {
      getPdfData(
        {
          url: `/api/vehicleWeighBridgeReport/?orgId=${localStorage.getItem(
            "orgId"
          )}&orgId=${Id}`,
        },
        (data) => {
          setPdfData(data);
          console.log(data);
        }
      );
    }
  };

  // useEffect(() => {
  //   const loadLogo = () => {
  //     const img = new Image();

  //     img.src = "/" + localStorage.getItem("organizationName") + ".jpg";
  //     console.log("img.src", img.src);
  //     img.crossOrigin = "anonymous";

  //     img.onload = () => {
  //       const canvas = document.createElement("canvas");
  //       canvas.width = img.width;
  //       canvas.height = img.height;
  //       const ctx = canvas.getContext("2d");
  //       ctx.drawImage(img, 0, 0);
  //       setLogoSrc(canvas.toDataURL("image/png"));
  //     };

  //     img.onerror = () => {
  //       if (orgData?.organizationIcon) {
  //         setLogoSrc(
  //           "dist/img/" + localStorage.getItem("organizationName") + ".jpg"
  //         );
  //       } else {
  //         setLogoSrc("");
  //       }
  //     };
  //   };

  //   loadLogo();
  // }, [orgData]);

  useEffect(() => {
    const imagePath = `/dist/img/TomatoJOLogo.jpg`;  // same as previous working code

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = imagePath;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      setLogoSrc(canvas.toDataURL("image/png"));
    };

    img.onerror = () => {
      console.error("Logo not found:", imagePath);
      setLogoSrc("");
    };
  }, []);



  const { sendRequest: getSeasonData } = useHttp();
  useEffect(() => {
    getSeasonData(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("season", data);

        setSeasondata(data);
      }
    );
  }, [getSeasonData]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">Weigh Bridge</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Crop Name</label>

                  <select
                    className="form-control"
                    value={cropId}
                    onChange={(e) => {
                      setCropId(e.target.value);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>

                    {cropData &&
                      cropData.map((x) => (
                        <option key={x.CropId} value={x.CropId}>
                          {x.CropName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>Season Name</label>
                  <select
                    id="seasonId"
                    className="form-control"
                    ref={(el) => (frmRef.current["seasonId"] = el)}
                    value={seasonId}
                    onChange={(e) => {
                      var sId = "";
                      if (e.target.value != "--Select--") {
                        sId = e.target.value;
                      }
                      // setSeasonName(sName);
                      setSeasonId(sId);
                      EmployeeDetail(sId);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {seasondata &&
                      seasondata.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>Vehicle Id</label>
                  <select
                    id="vehicleId"
                    className="form-control"
                    value={vehicleId}
                    onChange={(e) => {
                      setvehicleId(e.target.value || 0);
                      // EmployeeDetail(e.target.value || 0);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {vehicleData &&
                      vehicleData.map((x) => (
                        <option key={x.vmerId} value={x.vmerId}>
                          {x.VehicleCode}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>Field Officer</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div> */}
              {/* <div className="col-md-3">
                <label htmlFor="identification_number">
                  Identification Number
                </label>
                <AutoComplete
                  className="form-control"
                  style={{ width: "200px", height: "30px" }}
                  value={identificationNumber}
                  options={filteredOptions}
                  placeholder="Identification Number"
                  onChange={handleSearch}
                />
              </div> */}
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillprocurementData();
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-sm text-center">
                      <thead>
                        <tr>
                          <th>Harvest Date</th>
                          <th>Executive Name</th>
                          <th>Truck ID</th>
                          <th>Trip No</th>
                          <th>Crop Name</th>
                          <th>Season Name</th>
                          <th>Total Number of Crates</th>
                          <th>TARE Weight</th>
                          <th>Empty Wt of Truck</th>
                          <th>Weight of Crate</th>
                          <th>Total Weight of Crate</th>
                          <th>Adjusted weight</th>
                          <th>Average weight of crate</th>
                          <th>View</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length > 0 ? (
                          currentItems.map((item) => (
                            <tr key={item.tripId || item.VehicleCode}>
                              <td>{item.harvstDate || "-"}</td>
                              <td>{item.executiveName || "-"}</td>
                              <td>{item.VehicleCode || "N/A"}</td>
                              <td>{item.tripId || "-"}</td>
                              <td>{item.cropName}</td>
                              <td>{item.seasonName}</td>
                              <td>
                                {formatNumber(item.totalCratesBagQtyLoaded)}
                              </td>
                              <td>
                                {formatNumber(item.loadedVehicleWeightTons)}
                              </td>
                              <td>
                                {formatNumber(item.emptyVehicleWeightTons)}
                              </td>
                              <td>
                                {formatNumber(
                                  item.averageEmptyCratesWeightInKg
                                )}
                              </td>
                              <td>
                                {formatNumber(item.totalWeightofEmptyCrate)}
                              </td>
                              <td>{formatNumber(item.netWeightTons)}</td>
                              <td>
                                {formatNumber(item.averageWeightOfCrates)}
                              </td>

                              <td>
                                <button
                                  className="btn btn-link"
                                  title="View Details"
                                  onClick={() => viewPdf(item)}
                                >
                                  <i className="fas fa-eye text-primary" />
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={12} className="text-center">
                              No data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {pdfView && (
        <Modal isOpen={true} style={customModalStyles}>
          {/* PDF Styling */}
          <style>{`

/* ===================== EXPANDED TABLE FIX ===================== */

/* Let table grow naturally */
.pdf-container table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
  table-layout: auto !important;  /* 🔥 allow column expansion */
}

/* Default cell styling */
.pdf-container th,
.pdf-container td {
  border: 1px solid #000;
  padding: 8px;
  font-size: 13px;
  vertical-align: middle;
  text-align: center;
  background: #fff;
}

/* ---------- CUSTOM COLUMN WIDTHS ---------- */

/* # column */
.pdf-container th:nth-child(1),
.pdf-container td:nth-child(1) {
  width: 40px;
}

/* Farmer Name */
.pdf-container th:nth-child(2),
.pdf-container td:nth-child(2) {
  width: 180px;
  white-space: normal !important;
}

/* Farmer ID */
.pdf-container th:nth-child(3),
.pdf-container td:nth-child(3) {
  width: 140px;
  white-space: normal !important;
}

/* Crop Name */
.pdf-container th:nth-child(4),
.pdf-container td:nth-child(4) {
  width: 100px;
}

/* Harvest ID */
.pdf-container th:nth-child(5),
.pdf-container td:nth-child(5) {
  width: 70px;
}

/* Field */
.pdf-container th:nth-child(6),
.pdf-container td:nth-child(6) {
  width: 70px;
}

/* QTY of Crate */
.pdf-container th:nth-child(7),
.pdf-container td:nth-child(7) {
  width: 100px;
  white-space: nowrap !important;
}

/* Fruit Quality */
.pdf-container th:nth-child(8),
.pdf-container td:nth-child(8) {
  width: 100px;
}

/* AVG WT Crate */
.pdf-container th:nth-child(9),
.pdf-container td:nth-child(9) {
  width: 120px;
  white-space: nowrap !important;
}

/* Total WT */
.pdf-container th:nth-child(10),
.pdf-container td:nth-child(10) {
  width: 140px;
  white-space: nowrap !important;
}


/* ===================== WEIGH BRIDGE REPORT TABLE FIX ===================== */

.weigh-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
  margin-bottom: 20px !important;   /* ⭐ ADD SPACE BETWEEN TABLES */
}

.weigh-table th {
  background: #e6e6e6;
  text-align: left;
  padding: 8px 12px;                /* ⭐ More padding */
  font-weight: bold;
  white-space: nowrap !important;
}

.weigh-table td {
  border: 1px solid #000;
  padding: 8px 12px;                /* ⭐ More padding inside cells */
  vertical-align: middle;
  white-space: nowrap !important;
}

/* Label Column */
.weigh-label {
  width: 180px !important;
  text-align: left !important;
  font-weight: bold;
}

/* Value Column */
.weigh-value {
  width: 150px !important;
  text-align: right !important;
}

/* Equal row height */
.weigh-row {
  height: 32px !important;
}

`}</style>



          <div className="pdf-main-container">
            <div className="row no-print">
              <div className="col-md-11"></div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    onClick={() => setPdfView(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>

            <div
              className="pdf-container mx-3 my-4"
              ref={(el) => {
                pdfContainerRef.current = el;
                printRef.current = el;
              }}
            >
              <section className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12">
                      <div className="invoice p-3 mb-3">
                        {/* ==================== TITLE ROW ==================== */}
                        <div className="row">
                          <div className="col-12">
                            <div
                              className="title-row"
                              style={{
                                display: "flex",
                                alignItems: "center",      // vertically centers
                                justifyContent: "flex-start",
                                gap: "20px",
                                marginBottom: "15px",
                              }}
                            >
                              {logoSrc && (
                                <img
                                  src={logoSrc}
                                  width="70"
                                  height="70"
                                  alt="logo"
                                  style={{ objectFit: "contain" }}
                                />
                              )}

                              <h2
                                className="text-uppercase"
                                style={{ margin: 0, fontWeight: "bold" }}
                              >
                                WEIGH BRIDGE REPORT
                              </h2>
                            </div>

                          </div>
                        </div>

                        {/* ==================== INFO ROW ==================== */}
                        <div className="row invoice-info">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>
                              <div>
                                <strong>Field Name:</strong>{" "}
                                {pdfData?.farmerHarvestDetail?.[0]?.ranchName ||
                                  "N/A"}
                              </div>
                              <div>
                                <strong>Truck ID:</strong>{" "}
                                {pdfData?.vehicleCode || "N/A"}
                              </div>
                            </div>

                            <div style={{ marginLeft: "80px" }}>
                              <div>
                                <strong>Date:</strong>{" "}
                                {pdfData?.harvstDate || "N/A"}
                              </div>
                              <div>
                                <strong>Trip ID:</strong>{" "}
                                {pdfData?.tripId || "N/A"}
                              </div>
                              <div>
                                <strong>Pick NO:</strong>{" "}
                                {pdfData?.farmerHarvestDetail?.[0]
                                  ?.specificFieldPickId || "0"}
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* ==================== TABLE: HARVEST DETAILS ==================== */}
                        <div className="row mt-3">
                          <div className="col-12 table-responsive">
                            <table className="table table-bordered">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Farmer Name</th>
                                  <th>Farmer ID</th>
                                  <th>Crop Name</th>
                                  <th>Harvest ID</th>
                                  <th>Field</th>
                                  <th>QTY of Crate</th>
                                  <th>Fruit Quality</th>
                                  <th>AVG WT Crate</th>
                                  <th>Total WT</th>
                                </tr>
                              </thead>

                              <tbody>
                                {pdfData?.farmerHarvestDetail?.map((item, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.farmerName}</td>
                                    <td>{item.farmerNo}</td>
                                    <td>{item.cropName}</td>
                                    <td>{item.harvestId}</td>
                                    <td>{item.plotName || "NA"}</td>

                                    <td className="text-right">{item.cratesBagQtyLoaded}</td>
                                    <td>{item.fruitQuality}</td>
                                    <td className="text-right">{item.averageWeightOfCratesInKg}</td>

                                    <td className="text-right total-wt">
                                      {(item.cratesBagQtyLoaded * item.averageWeightOfCratesInKg).toFixed(2)}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>


                        {/* ==================== TABLE: WEIGH BRIDGE ==================== */}
                        <div className="row mt-3">
                          <div className="col-6 table-responsive">
                            <table className="weigh-table">
                              <tbody>
                                <tr>
                                  <th colSpan="2" className="text-left">
                                    Weigh Bridge Report
                                  </th>
                                </tr>

                                <tr>
                                  <td>
                                    <b>Tare Weigh :</b>
                                  </td>
                                  <td className="text-right">
                                    {pdfData?.loadedVehicleWeightTons ?? "N/A"}
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <b>Empty Truck WT :</b>
                                  </td>
                                  <td className="text-right">
                                    {pdfData?.emptyVehicleWeightTons ?? "N/A"}
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <b>AVG WT of Crate :</b>
                                  </td>
                                  <td className="text-right">
                                    {pdfData?.averageWeightOfCrates ?? "N/A"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {/* ==================== TABLE: SIGNATORY ==================== */}
                        <div className="row">
                          <div className="col-6">
                            <table className="table">
                              <tbody>
                                {/* <tr>
                                  <th>Witnesses</th>
                                  <td className="text-right">
                                    {data?.emptyVehicleWeightTons}
                                  </td>
                                </tr> */}

                                <tr>
                                  <th>Field Supervisor</th>
                                  <td>{pdfData?.employeeName ?? "N/A"}</td>
                                </tr>

                                <tr>
                                  <th>Weigh Bridge Officer</th>
                                  <td>
                                    {pdfData?.procurementOfficerId ?? "N/A"}
                                  </td>
                                </tr>

                                <tr>
                                  <th>Truck Driver</th>
                                  <td>{pdfData?.driverName ?? "N/A"}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div className="col-6">
                            <p className="text-muted">
                              Name of Authorized Signatory: {data?.employeeName}
                            </p>
                            <hr />
                            <p className="text-muted">
                              This is a Computer Generated Document
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            {/* ==================== PDF BUTTON ==================== */}
            <div className="row no-print">
              <div className="col-12">
                <button
                  type="button"
                  className="btn btn-primary float-right"
                  style={{ marginRight: 5 }}
                  onClick={() => generatePDF("WeighBridgeReport")}
                >
                  <i className="fas fa-download" /> Generate PDF
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default WeighBridgeReport;
